export default {
  path: '/transfer-pricing',
  component: () => import('@/views/transfer-pricing/Index'),
  redirect: { name: 'transfer-pricing-funding-payments' },
  meta: { title: 'Transfer Pricing', roles: ['general_manager'] },
  children: [
    {
      path: 'funding',
      component: () => import('@/views/transfer-pricing/funding/Layout'),
      meta: { title: 'Funding', roles: ['general_manager'] },
      children: [
        {
          path: 'payments',
          name: 'transfer-pricing-funding-payments',
          component: () => import('@/views/transfer-pricing/funding/List'),
          meta: { title: 'Funding — Payments', roles: ['general_manager'] },
        },
        {
          path: 'altezza-queue',
          name: 'transfer-pricing-funding-altezza-queue',
          component: () => import('@/views/transfer-pricing/funding/Queue'),
          props: { relationship: 'uae-to-altezza-tz' },
          meta: { title: 'Funding — Altezza Queue', roles: ['general_manager'] },
        },
        {
          path: 'altura-queue',
          name: 'transfer-pricing-funding-altura-queue',
          component: () => import('@/views/transfer-pricing/funding/Queue'),
          props: { recipient: 'ALTURA_EXPEDITIONS' },
          meta: { title: 'Funding — Altura Queue', roles: ['general_manager'] },
        },
      ],
    },
    {
      path: 'funding/payments/:id',
      name: 'transfer-pricing-funding-detail',
      component: () => import('@/views/transfer-pricing/funding/Detail'),
      meta: { title: 'Funding — Payment', roles: ['general_manager'] },
    },
  ],
}
